var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCheckCircle = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 1.66675C5.40768 1.66675 1.66602 5.40841 1.66602 10.0001C1.66602 14.5917 5.40768 18.3334 9.99935 18.3334C14.591 18.3334 18.3327 14.5917 18.3327 10.0001C18.3327 5.40841 14.591 1.66675 9.99935 1.66675ZM13.9827 8.08342L9.25768 12.8084C9.14102 12.9251 8.98268 12.9917 8.81602 12.9917C8.64935 12.9917 8.49102 12.9251 8.37435 12.8084L6.01602 10.4501C5.77435 10.2084 5.77435 9.80841 6.01602 9.56675C6.25768 9.32508 6.65768 9.32508 6.89935 9.56675L8.81602 11.4834L13.0993 7.20008C13.341 6.95842 13.741 6.95842 13.9827 7.20008C14.2243 7.44175 14.2243 7.83342 13.9827 8.08342Z",
    fill: "#3BB700"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check-circle.7156c37a.svg";
export { ForwardRef as ReactComponent };